package pl.finn.forms.ezw

object EzwData {

  val listOfTypesOfInformationIncludedInNotification = listOf(   //Rodzaj informacji zawartej w zawiadomieniu
    "0" to "1. Zawiadomienie dotyczące wierzyciela",
    "1" to "2. Zawiadomienie dotyczące zobowiązanego",
    "2" to "3. Zawiadomienie dotyczące tytułu/zarządzenia zabezpieczenia"
  )

  val listOfOptionsOfObligated = listOf(
    "0" to "Osoba fizyczna",
    "1" to "Podmiot niebędący osobą fizyczną",
    "2" to "Małżonkowie odpowiedzialni solidarnie"
  )

  val listOfReasonsForChangeInReceivablesOrNotificationCost = listOf(
    "Wyegzekwowanie" to "1. Wyegzekwowania należności pieniężnej przez inny organ egzekucyjny", // Wyegzekwowanie
    "Korekta" to "2. Korekty deklaracji/zeznania powodującej zmniejszenie wysokości należności pieniężnej", //Korekta
    "Przedawnienie" to "3. Przedawnienia należności pieniężnej", //Przedawnienie
    "Zaplata" to "4. Zapłaty wierzycielowi należności pieniężnej", //Zaplata
    "InneZdarzenie" to "5. Inne zdarzenia skutkujące zmniejszeniem wysokości należności", //InneZdarzenie
  )

  val listOfReasonPartOptions = listOf(//przesłanka do zawieszenia postępowania
    "w całości",
    "w części",
  )

  val listOfEntityTypes = listOf( //+1
  "0" to "małżonek",
  "1" to "przedstawiciel ustawowy",
  "2" to "kurator",
  "3" to "opiekun",
  "4" to "przedsiębiorca w spadku",
  "5" to "dłużnik rzeczowy",
  "6" to "inny",
  )

  val listOfEntityTypesInformationsAboutentityThatMadePayment = listOf( //+1
    "0" to "aktualny właściciel lub użytkownik wieczysty przedmiotu hipoteki przymusowej niebędących zobowiązanymi - jeżeli te należności są zabezpieczone tą hipoteką;",
    "1" to "aktualny właściciel przedmiotu zastawu skarbowego niebędącego zobowiązanym – jeżeli te należności są zabezpieczone tym zastawem;",
    "2" to "osoba trzecia, o której mowa w art.533 ustawy z dnia 23 kwietnia 1964 r.- Kodeks Cywilny (Dz.U. z 2019 r. poz.1145 i 1495);",
  )

  val listOfAdmIdNaturalPerson = listOf( //admIdOsobaFizyczna
    "0" to "PESEL",
    "1" to "NIP",
    "2" to "Inny identyfikator"
  )

  val listOfAdmIdNonPhisicalPerson = listOf( //admIdOsobaNiefizyczna
    "0" to "NIP",
    "1" to "REGON",
    "2" to "KRS",
    "3" to "Inny identyfikator"
  )

  val listOfBlocksEFG = listOf(
    "blokE" to "Blok E",
    "blokF" to "Blok F",
    "blokG" to "Blok G"
  )

}